import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';

// APIs
import { FeatureInitApi } from './apis/feature-init-api';
// import { FeatureInitApiImpl } from './apis/impls/feature-init-api';
import { AddTrialApi } from './apis/add-free-api';
import { AddTrialApiImpl } from './apis/impls/add-free-api';
import { AddProApi } from './apis/add-pro-api';
import { AddProApiImpl } from './apis/impls/add-pro-api';
import { PackageApi } from './apis/package-api';
import { PackageApiImpl } from './apis/impls/package-api';
import { StripeApi } from './apis/stripe-api';
import { StripeApiImpl } from './apis/impls/stripe-api';
import { UserSecurityControlApi } from './apis/user-security-control-api';
import { UserSecurityControlApiImpl } from './apis/impls/user-security-control-api';

// Models
import { PermissionV2Model } from './models/permission-v2-model';
import { PermissionV2ModelImpl } from './models/impls/permission-v2-model';

// Services
import { PermissionV2Service } from './services/permission-v2-service';
import { PermissionV2ServiceImpl } from './services/impls/permission-v2-service';
import { AddFreeService } from './services/add-free-service';
import { AddTrialServiceImpl } from './services/impls/add-free-service';
import { PackageInfoService } from './services/package-info-service';
import { PackageInfoServiceImpl } from './services/impls/package-info-service';
import { SubscriptionInfoService } from './services/subscription-info-service';
import { SubscriptionInfoServiceImpl } from './services/impls/subscription-info-service';
import { UserInfoService } from './services/user-info-service';
import { UserInfoServiceImpl } from './services/impls/user-info-service';
import { FeatureInitApiMock } from './apis/impls/feature-init-api-mock';
import { GenericFeaturePermissionService } from '../../services/feature-permission/generic-feature-permission-service';
import { GenericFeaturePermissionServiceImpl } from '../../services/feature-permission/impl/generic-feature-permission-service';
import { FeatureInitApiImpl } from './apis/impls/feature-init-api';
import { QueryFeaturePermissionsApi } from './apis/query-feature-permissions-api';
import { ShareModel } from './models/share-model';
import { ShareModelImpl } from './models/impls/share-model';

export const permissionV2Module = new ContainerModule((bind: interfaces.Bind) => {
    // Bind APIs
    bind(FeatureInitApiImpl).toSelf();
    bind(FeatureInitApi).to(FeatureInitApiMock);
    bind(AddTrialApi).to(AddTrialApiImpl);
    bind(AddProApi).to(AddProApiImpl);
    bind(PackageApi).to(PackageApiImpl);
    bind(StripeApi).to(StripeApiImpl);
    bind(UserSecurityControlApi).to(UserSecurityControlApiImpl).inSingletonScope();
    bind(QueryFeaturePermissionsApi).toService(FeatureInitApiImpl);

    // Bind Models
    bind(PermissionV2Model).to(PermissionV2ModelImpl);
    bind(ShareModel).to(ShareModelImpl);

    // Bind Services
    bind(PermissionV2Service).to(PermissionV2ServiceImpl);
    bind(AddFreeService).to(AddTrialServiceImpl);
    bind(PackageInfoService).to(PackageInfoServiceImpl);
    bind(SubscriptionInfoService).to(SubscriptionInfoServiceImpl);
    bind(UserInfoService).to(UserInfoServiceImpl);

    bind(GenericFeaturePermissionService).to(GenericFeaturePermissionServiceImpl);

});

// Export types and constants
export * from './types';
export * from './apis/feature-init-api';
export * from './apis/impls/feature-init-api-mock';
export * from './apis/add-free-api';
export * from './apis/add-pro-api';
export * from './apis/package-api';
export * from './apis/stripe-api';
export * from './apis/user-security-control-api';
export * from './composables/use-user-security-control';
export * from './models/permission-v2-model';
export * from './services/permission-v2-service';
export * from './services/add-free-service';
export * from './services/package-info-service';
export * from './services/subscription-info-service';
export * from './services/user-info-service';

// Export feature permission contribution types
export * from './feature-permission-types';
export * from './impls/feature-permission-registry';
